import React from "react";
import { useAuth } from "../_helper/Auth/AuthProvider";
import { normalizeUserRole } from "../Layout/Sidebar/Menu";
import Error403 from "../Components/Pages/ErrorPages/ErrorPage403";

const RoleGate = ({ roles, children }) => {
  const { userData } = useAuth();

  if (!roles || roles.length === 0) {
    return children;
  }

  const roleDbStr = JSON.stringify(normalizeUserRole(userData?.role)).toLowerCase();
  const hasMatch = roles.some((reqRole) =>
    roleDbStr.includes(String(reqRole).toLowerCase())
  );

  if (!hasMatch) {
    return <Error403 />;
  }

  return children;
};

export default RoleGate;
